import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
//
// Copia o texto de um target `source` para a área de transferência e dá um
// feedback temporário no botão que disparou a ação.
//
//   <div data-controller="clipboard">
//     <code data-clipboard-target="source">valor a copiar</code>
//     <button data-action="clipboard#copy" data-clipboard-target="button">Copiar</button>
//   </div>
//
// Values:
//   successLabel: rótulo mostrado no botão após copiar (default "Copiado!")
//   resetDelay:   ms até restaurar o botão ao estado original (default 2000)
export default class extends Controller {
  static targets = ["source", "button"]
  static values = {
    successLabel: { type: String, default: "Copiado!" },
    resetDelay: { type: Number, default: 2000 }
  }

  copy() {
    const texto = this.sourceTarget.textContent.trim()
    navigator.clipboard.writeText(texto).then(() => this.feedback())
  }

  feedback() {
    if (!this.hasButtonTarget) return

    // Guarda o conteúdo original só na primeira vez; cliques repetidos apenas
    // reiniciam o timer para não perder o HTML original (ícone + rótulo).
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout)
    } else {
      this.originalHtml = this.buttonTarget.innerHTML
    }

    this.buttonTarget.textContent = this.successLabelValue
    this.resetTimeout = setTimeout(() => {
      this.buttonTarget.innerHTML = this.originalHtml
      this.resetTimeout = null
    }, this.resetDelayValue)
  }

  disconnect() {
    if (this.resetTimeout) clearTimeout(this.resetTimeout)
  }
}
